// styled components
import { notification } from "antd";

export const Notificaciones = ({ titulo, descripcion, placement }: any) => {
  const openNotification = () => {
    notification.info({
      message: titulo,
      description: descripcion,
      placement,
    });
  };
  const mostrarNotificacion = () => {
    return openNotification();
  };
  return { mostrarNotificacion };
};
